import React, { Component } from "react";
import { connect } from "react-redux";
import { getNotificationCounter } from "../../../actions";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../common/breadcrumb";
import {
  getCall,
  postCallWithMedia,
  patchCall,
  putCall,
} from "../../../api/post";
import {
  loadUserDetailsFromLocalStorage,
  getValueFromLanguageObject,
  getColorCodeBasedOnKey,
  removeCurrentLanguage,
  saveUserDetailsToLocalStorage,
} from "../../../store";
import Avatar from "react-avatar";
import ImageUploader from "react-images-upload";
import {
  getProfileImageUrl,
  getMerchantInformationUrl,
  getCitiesUrl,
  getSignupOptionsUrl,
  getMasterDetailsIdUrl,
  getTenantInfoUrl,
  getSettingUrl,
  getGroupWiseGSTConfigurationUrl,
  getAddressDetailUrl,
} from "../../../services";
import MainLoader from "../../../animation/MainLoader";
import ErrorMessageAnimationModal from "../../../animation/ErrorMessageAnimationModal";
import SuccessMessageAnimationModal from "../../../animation/SuccessMessageAnimationModal";
import {
  clearLocalStorageReload,
  isOpenStoreIdExist,
  navigateTo,
  removeUserDetailAndOtherDetails,
} from "../../../utils/utils";
import { withRouter } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import SimpleReactValidator from "simple-react-validator";

const cityDropDownStyle = {
  fontSize: "12px",
  padding: "17px 25px",
  height: "54px",
  marginBottom: "50px",
};

class MyProfile extends Component {
  state = {
    cellNumber: "",
    cities: [],
    userName: "",
    companyName: "",
    cityId: "",
    emailId: "",
    userDetails: {},
    hoverStyle: { height: "500px" },
    isHover: true,
    isLoading: true,
    gstin: "",
    AppTitle: "",
    showErrorMessageModal: false,
    errorMessage: "",
    showSuccessMessageModal: false,
    successMessage: "",
    masterDetailsObj: {},
    maxCellnumberDigitLimit: "",
    text: "",
    countryList: [],
    stateList: [],
    cityList: [],
    shippingCountryList: [],
    shippingStateList: [],
    shippingCityList: [],
    groupWiseGSTINConfig: [],
  };

  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
  }

  componentDidMount = () => {
    const userDetails = loadUserDetailsFromLocalStorage();
    if (!isOpenStoreIdExist() && userDetails === undefined) {
      navigateTo(this.props, `/login`);
      return;
    }
    if (isOpenStoreIdExist()) {
      navigateTo(this.props, `/`);
      return;
    }

    this.initMasterDetailsId().then(() => {
      this.initCities();
      this.initSignUpOptions();
      this.initMerchantInfo();
      this.initUserDetails().then(() => {
        this.setState({ isLoading: false });
      });
      this.initTenantInfo();
      this.initCountryList();
      this.initShippingCountryList();
      this.initCatelogueSettings();
      this.initGroupWiseGSTINConfig();

      this.initAddressDetails();
    });
  };

  initMasterDetailsId = async () => {
    let masterDetailsObj = {};
    const publicUrl = window.location.pathname.split("/")[1];
    const masterDetailsIdUrl = getMasterDetailsIdUrl(publicUrl);
    const masterDetails = await getCall(masterDetailsIdUrl, []).then();
    if (masterDetails.error) {
      clearLocalStorageReload({ response: masterDetails });
    } else {
      if (masterDetails) {
        masterDetailsObj = masterDetails;
      }
    }
    this.setState({ masterDetailsObj: masterDetailsObj });
  };

  initCities = async () => {
    const { masterDetailsObj } = this.state;
    const cities = await getCall(getCitiesUrl(masterDetailsObj), []);
    if (cities.error) {
      clearLocalStorageReload({ response: cities });
    }
    this.setState({ cities: cities });
  };

  initUserDetails = async () => {
    const userDetails = loadUserDetailsFromLocalStorage();
    if (userDetails === undefined) {
      navigateTo(this.props, `/login`);
      return;
    }
    const userDetailUrl = `users/${userDetails.id}`;
    const userDetailsResponse = await getCall(userDetailUrl, []);

    if (userDetailsResponse.error) {
      clearLocalStorageReload({ response: userDetailsResponse });
      this.loadErrorMessageAnimation(userDetailsResponse.error.message);
      if (userDetailsResponse.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      this.setState({
        userDetails: userDetailsResponse,
        userName: userDetailsResponse.username,
        cellNumber: userDetailsResponse.cellnumber,
        emailId: userDetailsResponse.email,
        companyName: userDetailsResponse.companyname,
        cityId: userDetailsResponse.cityId,
        gstin: userDetailsResponse.gstin,
      });
      this.preFillUpBillingDetailForm(userDetailsResponse);
    }
  };

  initSignUpOptions = async () => {
    const { masterDetailsObj } = this.state;
    const signupOptions = await getCall(
      getSignupOptionsUrl(masterDetailsObj),
      []
    );
    if (signupOptions.error) {
      clearLocalStorageReload({ response: signupOptions });
    } else {
      if (signupOptions.length > 0) {
        this.setState({ signupOptions: JSON.parse(signupOptions[0].text) });
      }
    }
  };

  initMerchantInfo = async () => {
    const { masterDetailsObj } = this.state;
    const merchantInfoUrl = getMerchantInformationUrl(masterDetailsObj);
    const merchantInfo = await getCall(merchantInfoUrl, []);
    if (merchantInfo.error) {
      clearLocalStorageReload({ response: merchantInfo });
      this.setState({
        isMerchantGSTEnable: false,
        merchantInfo: {},
        AppTitle: "",
      });
    } else {
      this.setState({
        merchantInfo,
        AppTitle: merchantInfo.companyname,
        isMerchantGSTEnable: merchantInfo.enablegst === 0 ? false : true,
      });
    }
  };

  initTenantInfo = async () => {
    const { masterDetailsObj } = this.state;
    const { id } = masterDetailsObj || {};
    if (!id) {
      return;
    }
    const tenantInfoUrl = getTenantInfoUrl(id);
    const tenantInfo = await getCall(tenantInfoUrl, []);
    if (tenantInfo.error) {
      clearLocalStorageReload({ response: tenantInfo });
      this.loadErrorMessageAnimation(tenantInfo.error.message);
    } else {
      if (
        tenantInfo &&
        tenantInfo.length > 0 &&
        tenantInfo[0].text &&
        tenantInfo[0].text.length > 0
      ) {
        const tenantSettings = JSON.parse(tenantInfo[0].text);
        if ("maxCellnumberDigitLimit" in tenantSettings) {
          this.setState({
            maxCellnumberDigitLimit: tenantSettings.maxCellnumberDigitLimit,
          });
        } else {
          this.setState({
            maxCellnumberDigitLimit: "10",
          });
        }
      }
    }
  };

  // setting code start
  removeUserDetailAndRedirectToLogin = () => {
    removeUserDetailAndOtherDetails();
    removeCurrentLanguage();
    navigateTo(this.props, `/login`);
  };

  initCountryList = async () => {
    const countryUrl = `states?getCountries=getCountries`;
    const countryList = await getCall(countryUrl, []);
    if (countryList.error) {
      clearLocalStorageReload({ response: countryList });
      this.loadErrorMessageAnimation(countryList.error.message);
      if (countryList.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      this.setState({ countryList: countryList.data });
    }
  };

  initShippingCountryList = async () => {
    const countryUrl = `states?getCountries=getCountries`;
    const countryList = await getCall(countryUrl, []);
    if (countryList.error) {
      clearLocalStorageReload({ response: countryList });
      this.loadErrorMessageAnimation(countryList.error.message);
      if (countryList.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      this.setState({ shippingCountryList: countryList.data });
    }
  };

  initStateList = async () => {
    const { addressDetails } = this.state;
    const stateUrl =
      `states?filter[where][parentId]=` + this.state.billingCountry;
    const stateList = await getCall(stateUrl, []);
    if (stateList.error) {
      clearLocalStorageReload({ response: stateList });
      this.loadErrorMessageAnimation(stateList.error.message);
      if (stateList.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      this.setState({ stateList: stateList.data });
      if (
        stateList &&
        stateList.data &&
        addressDetails &&
        stateList.data[0] &&
        stateList.data[0].id &&
        addressDetails.length > 0 &&
        addressDetails[10].visible === 0
      ) {
        this.initCityListing(stateList.data[0].id);
      }
    }
  };

  initShippingStateList = async () => {
    const { addressDetails } = this.state;
    const stateUrl =
      `states?filter[where][parentId]=` + this.state.shippingCountry;
    const stateList = await getCall(stateUrl, []);
    if (stateList.error) {
      clearLocalStorageReload({ response: stateList });
      this.loadErrorMessageAnimation(stateList.error.message);
      if (stateList.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      this.setState({ shippingStateList: stateList.data });
      if (
        stateList &&
        stateList.data &&
        addressDetails &&
        addressDetails.length > 0 &&
        addressDetails[10].visible === 0
      ) {
        this.initShippingCityListing(stateList.data[0].id);
      }
    }
  };

  initCityList = async () => {
    const cityUrl = `cities?filter[where][stateId]=` + this.state.billingState;
    const cityList = await getCall(cityUrl, []);
    if (cityList.error) {
      clearLocalStorageReload({ response: cityList });
      this.loadErrorMessageAnimation(cityList.error.message);
      if (cityList.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      this.setState({ cityList: cityList.data });
    }
  };

  initCityListing = async (billingState) => {
    const cityUrl = `cities?filter[where][stateId]=` + billingState;
    const cityList = await getCall(cityUrl, []);
    if (cityList.error) {
      clearLocalStorageReload({ response: cityList });
      this.loadErrorMessageAnimation(cityList.error.message);
      if (cityList.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      this.setState({ cityList: cityList.data });
    }
  };

  initShippingCityList = async () => {
    const cityUrl = `cities?filter[where][stateId]=` + this.state.shippingState;
    const cityList = await getCall(cityUrl, []);
    if (cityList.error) {
      clearLocalStorageReload({ response: cityList });
      this.loadErrorMessageAnimation(cityList.error.message);
      if (cityList.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      this.setState({ shippingCityList: cityList.data });
    }
  };

  initShippingCityListing = async (shippingState) => {
    const cityUrl = `cities?filter[where][stateId]=` + shippingState;
    const cityList = await getCall(cityUrl, []);
    if (cityList.error) {
      clearLocalStorageReload({ response: cityList });
      this.loadErrorMessageAnimation(cityList.error.message);
      if (cityList.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      this.setState({ shippingCityList: cityList.data });
    }
  };

  initCatelogueSettings = async () => {
    const { masterDetailsObj } = this.state;
    const settingUrl = getSettingUrl(masterDetailsObj);
    const settingInfo = await getCall(settingUrl, []);
    if (settingInfo.error) {
      clearLocalStorageReload({ response: settingInfo });
    } else {
      let settings = {};
      settingInfo.forEach((setting) => {
        if (
          (setting.registerallow === "Catalogue_FMCG" ||
            setting.registerallow === "Catalogue_Jewellary" ||
            setting.registerallow === "Catalogue_Electronics" ||
            setting.registerallow === "Catalogue_FABRIC") &&
          setting.status === 1
        ) {
          settings = setting;
        }
      });
      this.setState({ currentCatelogueType: settings });
    }
  };

  initGroupWiseGSTINConfig = async () => {
    const { masterDetailsObj } = this.state;
    const groupWiseGSTINConfigUrl = getGroupWiseGSTConfigurationUrl(
      masterDetailsObj
    );
    const groupWiseGSTINConfig = await getCall(groupWiseGSTINConfigUrl, []);
    if (groupWiseGSTINConfig.error) {
      clearLocalStorageReload({ response: groupWiseGSTINConfig });
      this.loadErrorMessageAnimation(groupWiseGSTINConfig.error.message);
    } else {
      if (
        groupWiseGSTINConfig &&
        groupWiseGSTINConfig.length > 0 &&
        groupWiseGSTINConfig[0].status === 1
      ) {
        this.setState({
          groupWiseGSTINConfig: JSON.parse(groupWiseGSTINConfig[0].text),
        });
      }
    }
  };

  initAddressDetails = async () => {
    const { masterDetailsObj } = this.state;
    const addressDetails = await getCall(
      getAddressDetailUrl(masterDetailsObj),
      []
    );

    if (addressDetails.error) {
      clearLocalStorageReload({ response: addressDetails });
    } else {
      if (addressDetails.length > 0) {
        this.setState({ addressDetails: JSON.parse(addressDetails[0].text) });
      }
    }
  };

  preFillUpBillingDetailForm = (userDetailsResponse) => {
    const { billingaddress, shippingaddress } = userDetailsResponse;

    // Add proper checks before parsing JSON
    let billingAddress = null;
    let shippingAddress = null;

    try {
      if (
        billingaddress &&
        billingaddress !== "undefined" &&
        billingaddress !== "null"
      ) {
        billingAddress = JSON.parse(billingaddress);
      }
    } catch (error) {
      console.warn("Error parsing billing address:", error);
      billingAddress = null;
    }

    try {
      if (
        shippingaddress &&
        shippingaddress !== "undefined" &&
        shippingaddress !== "null"
      ) {
        shippingAddress = JSON.parse(shippingaddress);
      }
    } catch (error) {
      console.warn("Error parsing shipping address:", error);
      shippingAddress = null;
    }

    if (billingAddress) {
      const {
        name,
        mobile,
        email,
        companyname,
        gstin,
        address1,
        address2,
        landmark,
        cityId,
        stateId,
        countryId,
        zipcode,
        zonenumber,
        streetnumber,
        buildingnumber,
        unitnumber,
      } = billingAddress;
      this.setState({
        billingName: name || "",
        billingMobileNumber: mobile || "",
        billingEmailAddress: email || "",
        billingCompanyName: companyname || "",
        billingGSTIN: gstin || "",
        billingAddressLine1: address1 || "",
        billingAddressLine2: address2 || "",
        billingLandmark: landmark || "",
        billingPincode: zipcode || "",
        billingZonenumber: zonenumber || "",
        billingStreetnumber: streetnumber || "",
        billingBuildingnumber: buildingnumber || "",
        billingUnitnumber: unitnumber || "",
      });
      if (countryId) {
        this.initCountryList().then(() => {
          this.setState({ billingCountry: countryId }, () => {
            if (stateId) {
              this.initStateList().then(() => {
                this.setState({ billingState: stateId }, () => {
                  if (cityId) {
                    this.initCityList().then(() => {
                      this.setState({ billingCity: cityId });
                    });
                  }
                });
              });
            }
          });
        });
      }
    }

    if (shippingAddress) {
      const {
        name,
        mobile,
        email,
        companyname,
        gstin,
        address1,
        address2,
        landmark,
        cityId,
        stateId,
        countryId,
        zipcode,
        zonenumber,
        streetnumber,
        buildingnumber,
        unitnumber,
      } = shippingAddress;
      this.setState({
        shippingName: name || "",
        shippingMobileNumber: mobile || "",
        shippingEmailAddress: email || "",
        shippingCompanyName: companyname || "",
        shippingGSTIN: gstin || "",
        shippingAddressLine1: address1 || "",
        shippingAddressLine2: address2 || "",
        shippingZonenumber: zonenumber || "",
        shippingLandmark: landmark || "",
        shippingPincode: zipcode || "",
        shippingStreetnumber: streetnumber || "",
        shippingBuildingnumber: buildingnumber || "",
        shippingUnitnumber: unitnumber || "",
      });
      if (countryId) {
        this.initShippingCountryList().then(() => {
          this.setState({ shippingCountry: countryId }, () => {
            if (stateId) {
              this.initShippingStateList().then(() => {
                this.setState({ shippingState: stateId }, () => {
                  if (cityId) {
                    this.initShippingCityList().then(() => {
                      this.setState({ shippingCity: cityId });
                    });
                  }
                });
              });
            }
          });
        });
      }
    }
  };

  onChangeOfShippingCheckbox = (event) => {
    const {
      billingName,
      billingMobileNumber,
      billingEmailAddress,
      billingCompanyName,
      billingGSTIN,
      billingAddressLine1,
      billingAddressLine2,
      billingLandmark,
      billingCountry,
      billingState,
      billingCity,
      billingPincode,
      billingZonenumber,
      billingStreetnumber,
      billingBuildingnumber,
      billingUnitnumber,
    } = this.state;
    const isChecked = event.target.checked;
    this.setState({ chkShippingAddress: event.target.checked }, () => {
      if (isChecked) {
        this.setState({
          shippingName: billingName,
          shippingMobileNumber: billingMobileNumber,
          shippingEmailAddress: billingEmailAddress,
          shippingCompanyName: billingCompanyName,
          shippingGSTIN: billingGSTIN,
          shippingAddressLine1: billingAddressLine1,
          shippingAddressLine2: billingAddressLine2,
          shippingLandmark: billingLandmark,
          shippingPincode: billingPincode,
          shippingZonenumber: billingZonenumber,
          shippingStreetnumber: billingStreetnumber,
          shippingBuildingnumber: billingBuildingnumber,
          shippingUnitnumber: billingUnitnumber,
        });
        this.initShippingCountryList().then(() => {
          this.setState({ shippingCountry: billingCountry }, () => {
            this.initShippingStateList().then(() => {
              this.setState({ shippingState: billingState }, () => {
                this.initShippingCityList().then(() => {
                  this.setState({ shippingCity: billingCity });
                });
              });
            });
          });
        });
      }
    });
  };

  updateUserDetails = async () => {
    const {
      billingName,
      billingMobileNumber,
      billingEmailAddress,
      billingCompanyName,
      billingGSTIN,
      billingAddressLine1,
      billingAddressLine2,
      billingLandmark,
      billingCountry,
      billingState,
      billingCity,
      billingPincode,
      billingZonenumber,
      billingStreetnumber,
      billingBuildingnumber,
      billingUnitnumber,
      shippingName,
      shippingMobileNumber,
      shippingEmailAddress,
      shippingCompanyName,
      shippingGSTIN,
      shippingAddressLine1,
      shippingAddressLine2,
      shippingLandmark,
      shippingCountry,
      shippingState,
      shippingCity,
      shippingPincode,
      shippingZonenumber,
      shippingStreetnumber,
      shippingBuildingnumber,
      shippingUnitnumber,
    } = this.state;
    const userDetails = loadUserDetailsFromLocalStorage();
    if (userDetails === undefined) {
      return;
    }
    const { id } = userDetails;
    const userDetailsUrl = "users/" + id;
    const userDetailsObj = {
      shippingaddress: {
        name: shippingName,
        mobile: shippingMobileNumber,
        email: shippingEmailAddress,
        companyname: shippingCompanyName,
        gstin: shippingGSTIN,
        address1: shippingAddressLine1,
        address2: shippingAddressLine2,
        landmark: shippingLandmark,
        countryId: shippingCountry,
        stateId: shippingState,
        cityId: shippingCity,
        zipcode: shippingPincode,
        zonenumber: shippingZonenumber,
        streetnumber: shippingStreetnumber,
        buildingnumber: shippingBuildingnumber,
        unitnumber: shippingUnitnumber,
      },
      billingaddress: {
        name: billingName,
        mobile: billingMobileNumber,
        email: billingEmailAddress,
        companyname: billingCompanyName,
        gstin: billingGSTIN,
        address1: billingAddressLine1,
        address2: billingAddressLine2,
        landmark: billingLandmark,
        countryId: billingCountry,
        stateId: billingState,
        cityId: billingCity,
        zipcode: billingPincode,
        zonenumber: billingZonenumber,
        streetnumber: billingStreetnumber,
        buildingnumber: billingBuildingnumber,
        unitnumber: billingUnitnumber,
      },
      updateShippingPrice: true,
    };
    this.setState({ isLoading: true });
    const updateUserDetails = await patchCall(userDetailsUrl, userDetailsObj);
    this.setState({ isLoading: false });
    if (updateUserDetails.error) {
      clearLocalStorageReload({ response: updateUserDetails });
      this.loadErrorMessageAnimation(updateUserDetails.error.message);
      if (updateUserDetails.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      this.loadSuccessMessageAnimation(
        getValueFromLanguageObject(
          "Str_billing_shipping_address_edited_successfully"
        )
          ? getValueFromLanguageObject(
              "Str_billing_shipping_address_edited_successfully"
            )
          : "Billing/Shipping address edited successfully"
      );
      this.preFillUpBillingDetailForm(updateUserDetails);
      saveUserDetailsToLocalStorage(updateUserDetails);
    }
  };

  onClickOfSaveButton = () => {
    const userDetails = loadUserDetailsFromLocalStorage();
    if (userDetails === undefined) {
      return;
    }
    // if (this.state.chkShippingAddress) {
    //   console.log(this.state.chkShippingAddress);
    //   const {
    //     billingName,
    //     billingMobileNumber,
    //     billingEmailAddress,
    //     billingCompanyName,
    //     billingGSTIN,
    //     billingAddressLine1,
    //     billingAddressLine2,
    //     billingLandmark,
    //     billingPincode,
    //     groupWiseGSTINConfig,
    //     currentCatelogueType,
    //     billingZonenumber,
    //     billingStreetnumber,
    //     billingBuildingnumber,
    //     billingUnitnumber,
    //   } = this.state;
    //   let found = false;
    //   if (
    //     userDetails &&
    //     userDetails.groupId !== null &&
    //     userDetails.groupId !== undefined
    //   ) {
    //     const temp = groupWiseGSTINConfig.forEach((groupId) => {
    //       if (userDetails.groupId === groupId) {
    //         found = true;
    //       }
    //       return groupId;
    //     });
    //   }
    //   if (
    //     found &&
    //     currentCatelogueType &&
    //     currentCatelogueType.registerallow === "Catalogue_FMCG"
    //   ) {
    //     if (
    //       billingCompanyName === undefined ||
    //       billingCompanyName === "" ||
    //       billingCompanyName.trim().length === 0
    //     ) {
    //       this.loadErrorMessageAnimation(
    //         getValueFromLanguageObject("str_company_name_should_not_be_empty")
    //           ? getValueFromLanguageObject(
    //               "str_company_name_should_not_be_empty"
    //             )
    //           : "Company Name should not be empty!"
    //       );
    //       return;
    //     }
    //     if (
    //       billingGSTIN === undefined ||
    //       billingGSTIN === "" ||
    //       billingGSTIN.trim().length === 0
    //     ) {
    //       this.loadErrorMessageAnimation(
    //         getValueFromLanguageObject("str_gst_number_should_not_be_empty")
    //           ? getValueFromLanguageObject("str_gst_number_should_not_be_empty")
    //           : "GST Number should not be empty!"
    //       );
    //       return;
    //     }
    //   }
    //   this.setState(
    //     {
    //       shippingName: billingName,
    //       shippingMobileNumber: billingMobileNumber,
    //       shippingEmailAddress: billingEmailAddress,
    //       shippingCompanyName: billingCompanyName,
    //       shippingGSTIN: billingGSTIN,
    //       shippingAddressLine1: billingAddressLine1,
    //       shippingAddressLine2: billingAddressLine2,
    //       shippingLandmark: billingLandmark,
    //       shippingPincode: billingPincode,
    //       shippingZonenumber: billingZonenumber,
    //       shippingStreetnumber: billingStreetnumber,
    //       shippingBuildingnumber: billingBuildingnumber,
    //       shippingUnitnumber: billingUnitnumber,
    //     },
    //     () => {
    //       this.initShippingCountryList().then(() => {
    //         this.setState(
    //           { shippingCountry: this.state.billingCountry },
    //           () => {
    //             this.initShippingStateList().then(() => {
    //               this.setState(
    //                 { shippingState: this.state.billingState },
    //                 () => {
    //                   this.initShippingCityList().then(() => {
    //                     this.setState(
    //                       { shippingCity: this.state.billingCity },
    //                       () => {
    //                         if (this.validator.allValid()) {
    //                           // update user detail
    //                           this.updateUserDetails();
    //                         } else {
    //                           this.validator.showMessages();
    //                           this.forceUpdate();
    //                         }
    //                       }
    //                     );
    //                   });
    //                 }
    //               );
    //             });
    //           }
    //         );
    //       });
    //     }
    //   );
    // }
    // else {
    if (this.validator.allValid()) {
      // update user detail
      const {
        billingCompanyName,
        billingGSTIN,
        shippingCompanyName,
        shippingGSTIN,
        groupWiseGSTINConfig,
        currentCatelogueType,
      } = this.state;
      let found = false;
      if (
        userDetails &&
        userDetails.groupId !== null &&
        userDetails.groupId !== undefined
      ) {
        const temp = groupWiseGSTINConfig.map((groupId) => {
          if (userDetails.groupId === groupId) {
            found = true;
          }
          return groupId;
        });

        if (
          found &&
          currentCatelogueType &&
          currentCatelogueType.registerallow === "Catalogue_FMCG"
        ) {
          if (
            billingCompanyName === undefined ||
            billingCompanyName === "" ||
            billingCompanyName.trim().length === 0
          ) {
            this.loadErrorMessageAnimation(
              getValueFromLanguageObject("str_company_name_should_not_be_empty")
                ? getValueFromLanguageObject(
                    "str_company_name_should_not_be_empty"
                  )
                : "Company Name should not be empty!"
            );
            return;
          }
          if (
            billingGSTIN === undefined ||
            billingGSTIN === "" ||
            billingGSTIN.trim().length === 0
          ) {
            this.loadErrorMessageAnimation(
              getValueFromLanguageObject("str_gst_number_should_not_be_empty")
                ? getValueFromLanguageObject(
                    "str_gst_number_should_not_be_empty"
                  )
                : "GST Number should not be empty!"
            );
            return;
          }
          if (
            shippingCompanyName === undefined ||
            shippingCompanyName === "" ||
            shippingCompanyName.trim().length === 0
          ) {
            this.loadErrorMessageAnimation(
              getValueFromLanguageObject("str_company_name_should_not_be_empty")
                ? getValueFromLanguageObject(
                    "str_company_name_should_not_be_empty"
                  )
                : "Company Name should not be empty!"
            );
            return;
          }
          if (
            shippingGSTIN === undefined ||
            shippingGSTIN === "" ||
            shippingGSTIN.trim().length === 0
          ) {
            this.loadErrorMessageAnimation(
              getValueFromLanguageObject("str_gst_number_should_not_be_empty")
                ? getValueFromLanguageObject(
                    "str_gst_number_should_not_be_empty"
                  )
                : "GST Number should not be empty!"
            );
            return;
          }
        }
      }
      this.updateUserDetails();
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
    // }
  };

  onChangeOfBillingName = (event) => {
    this.setState({ billingName: event.target.value });
  };

  onChangeOfBillingMobileNumber = (event) => {
    this.setState({ billingMobileNumber: event.target.value });
  };
  onChangeOfBillingEmailAddress = (event) => {
    this.setState({ billingEmailAddress: event.target.value });
  };
  onChangeOfBillingCompanyName = (event) => {
    this.setState({ billingCompanyName: event.target.value });
  };

  onChangeOfBillingGSTIN = (event) => {
    this.setState({ billingGSTIN: event.target.value });
  };

  onChangeOfBillingAddressLine1 = (event) => {
    this.setState({ billingAddressLine1: event.target.value });
  };

  onChangeOfBillingAddressLine2 = (event) => {
    this.setState({ billingAddressLine2: event.target.value });
  };

  onChangeOfBillingLandmark = (event) => {
    this.setState({ billingLandmark: event.target.value });
  };

  onChangeOfBillingCountry = (event) => {
    this.setState({ billingCountry: event.target.value }, () => {
      this.initStateList();
    });
  };

  onChangeOfBillingState = (event) => {
    this.setState({ billingState: event.target.value }, () => {
      this.initCityList();
    });
  };

  onChangeOfBillingCity = (event) => {
    this.setState({ billingCity: event.target.value });
  };

  onChangeOfBillingPincode = (event) => {
    this.setState({ billingPincode: event.target.value });
  };

  onChangeOfBillingZonenumber = (event) => {
    this.setState({ billingZonenumber: event.target.value });
  };

  onChangeOfBillingStreetnumber = (event) => {
    this.setState({ billingStreetnumber: event.target.value });
  };

  onChangeOfBillingBuildingnumber = (event) => {
    this.setState({ billingBuildingnumber: event.target.value });
  };

  onChangeOfBillingUnitnumber = (event) => {
    this.setState({ billingUnitnumber: event.target.value });
  };

  onChangeOfShippingName = (event) => {
    this.setState({ shippingName: event.target.value });
  };

  onChangeOfShippingMobileNumber = (event) => {
    this.setState({ shippingMobileNumber: event.target.value });
  };
  onChangeOfShippingEmailAddress = (event) => {
    this.setState({ shippingEmailAddress: event.target.value });
  };
  onChangeOfShippingCompanyName = (event) => {
    this.setState({ shippingCompanyName: event.target.value });
  };

  onChangeOfShippingGSTIN = (event) => {
    this.setState({ shippingGSTIN: event.target.value });
  };

  onChangeOfShippingAddressLine1 = (event) => {
    this.setState({ shippingAddressLine1: event.target.value });
  };

  onChangeOfShippingAddressLine2 = (event) => {
    this.setState({ shippingAddressLine2: event.target.value });
  };

  onChangeOfShippingZonenumber = (event) => {
    this.setState({ shippingZonenumber: event.target.value });
  };

  onChangeOfShippingStreetnumber = (event) => {
    this.setState({ shippingStreetnumber: event.target.value });
  };

  onChangeOfShippingBuildingnumber = (event) => {
    this.setState({ shippingBuildingnumber: event.target.value });
  };

  onChangeOfShippingUnitnumber = (event) => {
    this.setState({ shippingUnitnumber: event.target.value });
  };

  onChangeOfShippingLandmark = (event) => {
    this.setState({ shippingLandmark: event.target.value });
  };

  onChangeOfShippingCountry = (event) => {
    this.setState({ shippingCountry: event.target.value }, () => {
      this.initShippingStateList();
    });
  };

  onChangeOfShippingState = (event) => {
    this.setState({ shippingState: event.target.value }, () => {
      this.initShippingCityList();
    });
  };

  onChangeOfShippingCity = (event) => {
    this.setState({ shippingCity: event.target.value });
  };

  onChangeOfShippingPincode = (event) => {
    this.setState({ shippingPincode: event.target.value });
  };

  loadErrorMessageAnimation = (message) => {
    this.setState({ errorMessage: message, showErrorMessageModal: true });
  };

  loadSuccessMessageAnimation = (message) => {
    this.setState({ successMessage: message, showSuccessMessageModal: true });
  };
  //setting code end

  handleChangeOfUserName = (event) => {
    const regex = /^[a-zA-Z _]*$/;
    if (!regex.test(event.target.value)) {
      return;
    }
    this.setState({ userName: event.target.value });
  };

  handleChangeOfCellNumber = (event) => {
    const number = event.target.value.trim();

    if (!isNaN(number)) {
      this.setState({ cellNumber: number });
    } else {
      return;
    }
  };

  handleChangeOfCompanyName = (event) => {
    this.setState({ companyName: event.target.value });
  };
  handleChangeOfEmailId = (event) => {
    this.setState({ emailId: event.target.value });
  };

  handleChangeOfCity = (event) => {
    this.setState({ cityId: event.target.value });
  };

  handleChangeOfGSTIN = (event) => {
    this.setState({ gstin: event.target.value });
  };

  onClickOfSaveChanges = () => {
    const {
      userName,
      cellNumber,
      emailId,
      companyName,
      cityId,
      gstin,
      signupOptions,
      maxCellnumberDigitLimit,
    } = this.state;
    const maxCellnumberDigitLimitInt = parseInt(maxCellnumberDigitLimit);
    if (userName.trim().length < 3 || userName.trim().length === 0) {
      this.loadErrorMessageAnimation(
        getValueFromLanguageObject("str_please_enter_valid_user_name")
          ? getValueFromLanguageObject("str_please_enter_valid_user_name")
          : "Please Enter Valid User Name."
      );
      return;
    }

    if (
      signupOptions[0].field_name === "Name" &&
      signupOptions[0].mandatory === 1 &&
      signupOptions[0].visible === 1 &&
      userName &&
      (userName.trim().length < 3 || userName.trim().length === 0)
    ) {
      this.loadErrorMessageAnimation(
        getValueFromLanguageObject("str_please_enter_valid_name")
          ? getValueFromLanguageObject("str_please_enter_valid_name")
          : "Please Enter Valid Name."
      );
      return;
    }
    if (
      signupOptions[5].field_name === "Mobile Number" &&
      signupOptions[5].mandatory === 1 &&
      signupOptions[5].visible === 1 &&
      cellNumber &&
      cellNumber.trim().length !== maxCellnumberDigitLimitInt
    ) {
      this.loadErrorMessageAnimation(
        getValueFromLanguageObject("msg_enter_mobile_number_incorrect")
          ? getValueFromLanguageObject("msg_enter_mobile_number_incorrect")
          : "Please enter correct mobile number."
      );
      return;
    }

    if (emailId && emailId.trim().length > 0) {
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,4}))$/;
      if (!re.test(emailId)) {
        this.loadErrorMessageAnimation(
          getValueFromLanguageObject("str_please_enter_valid_email_address")
            ? getValueFromLanguageObject("str_please_enter_valid_email_address")
            : "Please Enter Valid Email Address"
        );
        return;
      }
    }

    if (
      signupOptions[4].field_name === "Company Name" &&
      signupOptions[4].mandatory === 1 &&
      signupOptions[4].visible === 1 &&
      companyName &&
      companyName.trim().length === 0
    ) {
      this.loadErrorMessageAnimation(
        getValueFromLanguageObject("msg_enter_company_name_incorrect")
          ? getValueFromLanguageObject("msg_enter_company_name_incorrect")
          : "Please enter company name."
      );
      return;
    }

    if (cityId && cityId.trim().length === 0) {
      this.loadErrorMessageAnimation(
        getValueFromLanguageObject("str_please_select_city")
          ? getValueFromLanguageObject("str_please_select_city")
          : "Please Select City."
      );
      return;
    }

    if (
      (signupOptions[1].field_name === "Email" &&
        signupOptions[1].mandatory === 1 &&
        signupOptions[1].visible === 1) ||
      (emailId && emailId.trim().length > 0)
    ) {
      const re = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
      if (!re.test(emailId)) {
        this.loadErrorMessageAnimation(
          getValueFromLanguageObject("str_please_enter_valid_email_address")
            ? getValueFromLanguageObject("str_please_enter_valid_email_address")
            : "Please Enter Valid Email Address."
        );
        return;
      }
    }

    if (
      (signupOptions[2].field_name === "GSTIN" &&
        signupOptions[2].mandatory === 1 &&
        signupOptions[2].visible === 1) ||
      (gstin && gstin.trim().length > 0)
    ) {
      const re = /^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/;
      if (!re.test(gstin)) {
        this.loadErrorMessageAnimation(
          getValueFromLanguageObject("str_please_enter_valid_gst_number")
            ? getValueFromLanguageObject("str_please_enter_valid_gst_number")
            : "Please Enter Valid GST Number."
        );
        return;
      }
    }

    this.editProfileInformation();
  };

  editProfileInformation = () => {
    try {
      this.setState({ isLoading: true }, async () => {
        const userDetails = loadUserDetailsFromLocalStorage();
        if (userDetails === undefined) {
          return;
        }
        const editProfileUrl = "users/" + userDetails.id;
        const editProfileObj = {
          username: this.state.userName,
          cellnumber: this.state.cellNumber,
          email: this.state.emailId ? this.state.emailId.toLowerCase() : "",
          companyname: this.state.companyName,
          cityId: this.state.cityId,
          gstin: this.state.gstin,
        };
        const editProfile = await putCall(editProfileUrl, editProfileObj);
        this.setState({ isLoading: false });
        if (editProfile.error) {
          clearLocalStorageReload({ response: editProfile });
          this.loadErrorMessageAnimation(editProfile.error.message);
          if (editProfile.error.statusCode === 401) {
            removeUserDetailAndOtherDetails();
            navigateTo(this.props, `/login`);
            return;
          }
        } else {
          this.loadSuccessMessageAnimation(
            getValueFromLanguageObject(
              "str_profile_information_updated_successfully"
            )
              ? getValueFromLanguageObject(
                  "str_profile_information_updated_successfully"
                )
              : "Profile Information updated successfully"
          );
          this.setState({ isLoading: true }, () => {
            this.initUserDetails().then(() => {
              this.setState({ isLoading: false });
            });
          });
        }
      });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  toggleEnterHover = () => {
    this.setState({ isHover: true });
  };

  toggleLeaveHover = () => {
    this.setState({ isHover: true });
  };

  onClickOfEditProfile = async (picture) => {
    try {
      const { masterDetailsObj } = this.state;
      // return;
      this.setState({ isLoading: true }, async () => {
        const uploadImageUrl = `containers/profilepic-${masterDetailsObj.codename}/upload`;
        const uploadImage = await postCallWithMedia(
          uploadImageUrl,
          picture[0],
          "profilepic"
        );
        this.setState({ isLoading: false });
        if (uploadImage.error) {
          clearLocalStorageReload({ response: uploadImage });
          this.loadErrorMessageAnimation(uploadImage.error.message);
        } else {
          const { result } = uploadImage || {};
          const { files } = result || {};
          const { profilepic } = files || {};
          const { name } = profilepic[0] || {};
          if (name) {
            const userDetails = loadUserDetailsFromLocalStorage();
            if (userDetails === undefined) {
              return;
            }
            const updateUserDetailUrl = `users/${userDetails.id}`;
            const updateUserDetailObj = {
              id: userDetails.id,
              profilepic: uploadImage.result.files.profilepic[0].name,
            };
            const updateUserDetail = await patchCall(
              updateUserDetailUrl,
              updateUserDetailObj
            );
            if (updateUserDetail.error) {
              clearLocalStorageReload({ response: updateUserDetail });
              this.loadErrorMessageAnimation(updateUserDetail.error.message);
            } else {
              this.loadSuccessMessageAnimation(
                getValueFromLanguageObject(
                  "str_profile_picture_is_updated_successfully"
                )
                  ? getValueFromLanguageObject(
                      "str_profile_picture_is_updated_successfully"
                    )
                  : "Profile Picture is updated successfully"
              );
              this.setState({ isLoading: true }, () => {
                this.initUserDetails().then(() => {
                  this.setState({ isLoading: false });
                });
              });
            }
          }
        }
      });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  renderSaveChanges = () => {
    const {
      userDetails,
      userName,
      cellNumber,
      emailId,
      companyName,
      cityId,
      gstin,
    } = this.state;
    if (
      (userDetails && userDetails.username !== userName) ||
      userDetails.cellnumber !== cellNumber ||
      userDetails.email !== emailId ||
      userDetails.companyname !== companyName ||
      userDetails.cityId !== cityId ||
      userDetails.gstin !== gstin
    ) {
      return (
        <>
          {/* <div className="row"> */}
          {/* <div className="col-6" /> */}
          <div
            onClick={() => {
              this.onClickOfSaveChanges();
            }}
            className="btn btn-solid pull-right save-button"

            // style={{
            //   color: getColorCodeBasedOnKey("text_save_changes_my_profile"),
            //   backgroundImage: `linear-gradient(30deg, ${getColorCodeBasedOnKey(
            //     "bg_save_changes_my_profile"
            //   )} 50%, transparent 50%)`,
            //   float: "right",
            //   marginBottom: "50px",
            // }}
          >
            {getValueFromLanguageObject("str_save_changes")
              ? getValueFromLanguageObject("str_save_changes")
              : "Save Changes"}
          </div>
          {/* </div> */}
        </>
      );
    } else {
      return;
    }
  };

  loadErrorMessageAnimation = (message) => {
    this.setState({ errorMessage: message, showErrorMessageModal: true });
  };

  loadSuccessMessageAnimation = (message) => {
    this.setState({ successMessage: message, showSuccessMessageModal: true });
  };

  render() {
    const {
      userDetails,
      AppTitle,
      isLoading,
      masterDetailsObj,
      showErrorMessageModal,
      errorMessage,
      showSuccessMessageModal,
      successMessage,
    } = this.state;

    // Parse billing and shipping addresses
    let billing = [];
    let shipping = [];
    try {
      billing = userDetails.billingaddress
        ? JSON.parse(userDetails.billingaddress)
        : [];
    } catch (e) {}
    try {
      shipping = userDetails.shippingaddress
        ? JSON.parse(userDetails.shippingaddress)
        : [];
    } catch (e) {}

    const billingAddr = billing[0] || {};
    const shippingAddr = shipping[0] || {};

    return (
      <>
        <Helmet>
          <title>{AppTitle} | My Profile</title>
        </Helmet>
        <Breadcrumb title="My Profile" />

        <div className="container mt-5">
          <div className="row justify-content-center">
            <div className="col-12 card">
              <Tabs>
                <div className="card-body">
                  <TabList>
                    <Tab>PERSONAL DETAILS</Tab>
                    <Tab>ADDRESS DETAILS</Tab>
                  </TabList>
                  <TabPanel>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="theme-card d-flex flex-column align-items-start p-5">
                          <div>
                            <Avatar
                              name={
                                userDetails.firstname +
                                " " +
                                userDetails.lastname
                              }
                              size="120"
                              round={true}
                            />
                          </div>
                          <div className="w-100 mt-3">
                            <div className="row">
                              <div className="col-md-6 mb-3">
                                <label>Name</label>
                                <div
                                  style={{
                                    padding: "10px 16px",
                                    background: "#f8f8f8",
                                    borderRadius: "6px",
                                  }}
                                >
                                  {userDetails.firstname} {userDetails.lastname}
                                </div>
                              </div>
                              <div className="col-md-6 mb-3">
                                <label>Mobile Number</label>
                                <div
                                  style={{
                                    padding: "10px 16px",
                                    background: "#f8f8f8",
                                    borderRadius: "6px",
                                  }}
                                >
                                  {userDetails.cellnumber}
                                </div>
                              </div>
                              <div className="col-md-6 mb-3">
                                <label>Email Address</label>
                                <div
                                  style={{
                                    padding: "10px 16px",
                                    background: "#f8f8f8",
                                    borderRadius: "6px",
                                  }}
                                >
                                  {userDetails.email}
                                </div>
                              </div>
                              <div className="col-md-6 mb-3">
                                <label>Username</label>
                                <div
                                  style={{
                                    padding: "10px 16px",
                                    background: "#f8f8f8",
                                    borderRadius: "6px",
                                  }}
                                >
                                  {userDetails.username}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="theme-card" style={{ padding: "24px" }}>
                          <h4 className="text-dark fw-bold">Billing Address</h4>
                          <div
                            className="d-flex flex-column mt-2"
                            style={{ gap: "6px" }}
                          >
                            {billingAddr.name && (
                              <div>
                                <b>Name:</b> {billingAddr.name}
                              </div>
                            )}
                            {billingAddr.phone && (
                              <div>
                                <b>Phone:</b> {billingAddr.phone}
                              </div>
                            )}
                            {billingAddr.addressline1 && (
                              <div>
                                <b>Address 1:</b> {billingAddr.addressline1}
                              </div>
                            )}
                            {billingAddr.addressline2 && (
                              <div>
                                <b>Address 2:</b> {billingAddr.addressline2}
                              </div>
                            )}
                            {billingAddr.city && (
                              <div>
                                <b>City:</b> {billingAddr.city}
                              </div>
                            )}
                            {billingAddr.state && (
                              <div>
                                <b>State:</b> {billingAddr.state}
                              </div>
                            )}
                            {billingAddr.zipcode && (
                              <div>
                                <b>Zipcode:</b> {billingAddr.zipcode}
                              </div>
                            )}
                            {billingAddr.country && (
                              <div>
                                <b>Country:</b> {billingAddr.country}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="theme-card" style={{ padding: "24px" }}>
                          <h4 className="text-dark fw-bold">
                            Shipping Address
                          </h4>
                          <div
                            className="d-flex flex-column mt-2"
                            style={{ gap: "6px" }}
                          >
                            {shippingAddr.name && (
                              <div>
                                <b>Name:</b> {shippingAddr.name}
                              </div>
                            )}
                            {shippingAddr.phone && (
                              <div>
                                <b>Phone:</b> {shippingAddr.phone}
                              </div>
                            )}
                            {shippingAddr.addressline1 && (
                              <div>
                                <b>Address 1:</b> {shippingAddr.addressline1}
                              </div>
                            )}
                            {shippingAddr.addressline2 && (
                              <div>
                                <b>Address 2:</b> {shippingAddr.addressline2}
                              </div>
                            )}
                            {shippingAddr.city && (
                              <div>
                                <b>City:</b> {shippingAddr.city}
                              </div>
                            )}
                            {shippingAddr.state && (
                              <div>
                                <b>State:</b> {shippingAddr.state}
                              </div>
                            )}
                            {shippingAddr.zipcode && (
                              <div>
                                <b>Zipcode:</b> {shippingAddr.zipcode}
                              </div>
                            )}
                            {shippingAddr.country && (
                              <div>
                                <b>Country:</b> {shippingAddr.country}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </div>
              </Tabs>
            </div>
          </div>
        </div>
        {isLoading && <MainLoader />}
        {showErrorMessageModal && (
          <ErrorMessageAnimationModal
            show={showErrorMessageModal}
            message={errorMessage}
            onClose={() => {
              this.setState({ showErrorMessageModal: false });
            }}
          />
        )}
        {showSuccessMessageModal && (
          <SuccessMessageAnimationModal
            show={showSuccessMessageModal}
            message={successMessage}
            onClose={() => {
              this.setState({ showSuccessMessageModal: false });
            }}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  baseCurrency: state.settings.baseCurrency,
});

export default connect(mapStateToProps, {
  notificationCounter: getNotificationCounter,
})(withRouter(MyProfile));
